"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Model = _interopRequireDefault(require("./Model"));
var _utilities = require("../utilities");
var _enums = require("../enums");
var _View = _interopRequireDefault(require("./View"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["config"],
  _excluded2 = ["config"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // Controller.js
// hooks
// utilities
// enums
// components
function Controller(_ref) {
  var _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$temperatureUnits = _ref.temperatureUnits,
    temperatureUnits = _ref$temperatureUnits === void 0 ? "F" : _ref$temperatureUnits,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive,
    _ref$activeMarker = _ref.activeMarker,
    activeMarker = _ref$activeMarker === void 0 ? "" : _ref$activeMarker;
  var _useIRRenderer = (0, _Model.default)(),
    isReady = _useIRRenderer.isReady,
    imageInfo = _useIRRenderer.imageInfo,
    _useIRRenderer$images = _useIRRenderer.images,
    images = _useIRRenderer$images === void 0 ? {} : _useIRRenderer$images,
    _useIRRenderer$marker = _useIRRenderer.markersAsArray,
    markersAsArray = _useIRRenderer$marker === void 0 ? [] : _useIRRenderer$marker,
    paletteGradient = _useIRRenderer.paletteGradient,
    loadImages = _useIRRenderer.loadImages,
    updateSettings = _useIRRenderer.updateSettings,
    updateMarker = _useIRRenderer.updateMarker,
    getPixelTemp = _useIRRenderer.getPixelTemp;
  var stageRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    lastSavedImage = _useState2[0],
    setLastSavedImage = _useState2[1];
  var formatTemperature = (0, _react.useCallback)(function (tempCelcius) {
    return (0, _utilities.getDisplayTemperature)(tempCelcius, temperatureUnits);
  }, [temperatureUnits]);
  var getDisplayTemperatureFromCoords = (0, _react.useCallback)(function (_ref2) {
    var _x, _y;
    var x = _ref2.x,
      y = _ref2.y,
      X = _ref2.X,
      Y = _ref2.Y;
    // absolute position on canvas
    x = parseInt((_x = x) !== null && _x !== void 0 ? _x : X, 10);
    y = parseInt((_y = y) !== null && _y !== void 0 ? _y : Y, 10);
    var pixelTemp = getPixelTemp(x, y);
    return formatTemperature(pixelTemp, temperatureUnits);
  }, [formatTemperature, getPixelTemp, temperatureUnits]);
  var saveImageCallback = (0, _react.useCallback)(function () {
    /**
     * ESCAPE HATCH:
     * pass updated image data back up the parent
     *  */

    // Pass updated image data back up the parent
    if (lastSavedImage instanceof HTMLImageElement) {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        DATA: {
          img: lastSavedImage,
          json: imageInfo,
          imageId: data === null || data === void 0 ? void 0 : data.id
        },
        PALETTE_NAMES: _enums.PaletteNames,
        PALETTE_GRADIENT: paletteGradient
      });
    }
  }, [data === null || data === void 0 ? void 0 : data.id, imageInfo, lastSavedImage, onChange, paletteGradient]);
  var storeCanvasImage = (0, _react.useCallback)(function (img) {
    if (img) {
      // Save the current canvas image
      setLastSavedImage(img);
    }
  }, []);
  var irOrientation = (0, _react.useMemo)(function () {
    return (0, _utilities.getIRPaletteSetup)(imageInfo).irOrientation;
  }, [imageInfo]);
  var globalMarkerVisible = (0, _react.useMemo)(function () {
    return (0, _utilities.getIRVIEWERProps)(imageInfo).globalMarkerVisible;
  }, [imageInfo]);

  // DATA PROP CHANGES =====================================================
  (0, _react.useEffect)(function () {
    // if imageInfo or lastSavedImage updates
    saveImageCallback();
  }, [imageInfo, lastSavedImage, saveImageCallback]);
  (0, _react.useEffect)(function () {
    // when external data prop has changed or new image-id
    if (isReady && Object.keys(data).length > 0) {
      // prepare canvas with new rendered images
      loadImages(data);
    }
  }, [isReady, loadImages, data]);

  // CONFIG PROP CHANGES =====================================================
  (0, _react.useEffect)(function () {
    var _config$delay;
    // handle updates for renderer settings with optional debounce

    var debouncedUpdate = (0, _utilities.debounce)(function (nextSettings) {
      updateSettings(nextSettings);
    }, (_config$delay = config === null || config === void 0 ? void 0 : config.delay) !== null && _config$delay !== void 0 ? _config$delay : 0);
    if (Object.keys(settings).length > 0) {
      var _config$debounce;
      if ((_config$debounce = config === null || config === void 0 ? void 0 : config.debounce) !== null && _config$debounce !== void 0 ? _config$debounce : false) {
        // debounce settings update
        debouncedUpdate(settings);
      } else {
        // immediate settings update
        updateSettings(settings);
      }
    }
    return function () {
      // Clear the timeout when the component unmounts
      debouncedUpdate.cancel();
    };
  }, [config === null || config === void 0 ? void 0 : config.debounce, config === null || config === void 0 ? void 0 : config.delay, settings, updateSettings]);
  (0, _react.useEffect)(function () {
    return function () {
      // free stage when the component unmounts
      if (stageRef.current) {
        stageRef.current.destroy();
        stageRef.current = null;
      }
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    config: config,
    images: images,
    markers: markersAsArray !== null && markersAsArray !== void 0 ? markersAsArray : [],
    rotation: irOrientation,
    isMarkerLayerVisible: globalMarkerVisible,
    interactive: interactive,
    activeMarker: activeMarker !== null && activeMarker !== void 0 ? activeMarker : "",
    onMarkerChange: updateMarker,
    onCursorChange: getDisplayTemperatureFromCoords,
    onChange: storeCanvasImage,
    onDisplay: formatTemperature
  });
}
function arePropsEqual() {
  var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _prevProps$config = prevProps.config,
    prevConfig = _prevProps$config === void 0 ? {} : _prevProps$config,
    restPrevProps = _objectWithoutProperties(prevProps, _excluded);
  var _nextProps$config = nextProps.config,
    nextConfig = _nextProps$config === void 0 ? {} : _nextProps$config,
    restNextProps = _objectWithoutProperties(nextProps, _excluded2);
  var prevEntries = Object.entries(restPrevProps);
  var nextEntries = Object.entries(restNextProps);

  // do prop lengths match?
  if (prevEntries.length !== nextEntries.length) {
    return false;
  }

  // check all props but config object
  for (var _i = 0, _prevEntries = prevEntries; _i < _prevEntries.length; _i++) {
    var _prevEntries$_i = _slicedToArray(_prevEntries[_i], 2),
      key = _prevEntries$_i[0],
      value = _prevEntries$_i[1];
    if (nextProps[key] !== value) {
      return false;
    }
  }

  // check config object
  var prevConfigEntries = Object.entries(prevConfig);
  var nextConfigEntries = Object.entries(nextConfig);
  if (prevConfigEntries.length !== nextConfigEntries.length) {
    return false;
  }
  for (var _i2 = 0, _prevConfigEntries = prevConfigEntries; _i2 < _prevConfigEntries.length; _i2++) {
    var _prevConfigEntries$_i = _slicedToArray(_prevConfigEntries[_i2], 2),
      _key = _prevConfigEntries$_i[0],
      _value = _prevConfigEntries$_i[1];
    if (nextConfig[_key] !== _value) {
      return false;
    }
  }

  // No changes detected, return true to prevent rerender
  return true;
}
var _default = exports.default = /*#__PURE__*/_react.default.memo(Controller, arePropsEqual);